import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { UXFB_CLIENT_EVENTS_CONFIG_KEY, UXFB_EVENT_SEARCH_LISTING } from 'shared/map-search/constants/uxfb';
import { useApplicationContext } from 'shared/map-search/containers/ApplicationContext';
import { selectJsonQuery } from 'shared/map-search/selectors/results';
import { sendUXSEventWhenReady } from 'shared/map-search/utils/uxs';
import { getSearchListingAttributes } from 'shared/map-search/utils/uxs/serpEventAttributes';

/**
 * Шлёт UXFB-событие `search_listing` один раз при заходе на карту (mount) с атрибутами вертикали/сделки
 * и `view_mode=map`. Применения фильтров покрываются отдельным событием `serp_filter_applied`
 * (шлётся из микрофронта фильтров).
 *
 * `dedupeKey` обязателен: useRef не переживает ремаунт контейнера, дубль события засчитывается
 * бэкендом UXFB как лишний «заход», и кампании «на 2-й заход» выезжают уже на первом.
 */
export function useSearchListingUxfbEvent(): void {
  const { config } = useApplicationContext();
  const jsonQuery = useSelector(selectJsonQuery);
  const deviceType = useDeviceType();
  const hasSentRef = React.useRef(false);

  React.useEffect(() => {
    if (hasSentRef.current) {
      return;
    }

    if (config.get<boolean>(UXFB_CLIENT_EVENTS_CONFIG_KEY) === false) {
      return;
    }

    hasSentRef.current = true;

    sendUXSEventWhenReady(
      UXFB_EVENT_SEARCH_LISTING,
      getSearchListingAttributes({ jsonQuery, deviceType, viewMode: 'map' }),
      {
        dedupeKey: UXFB_EVENT_SEARCH_LISTING,
      },
    );
  }, [config, jsonQuery, deviceType]);
}
